import {Controller} from '@hotwired/stimulus'
import $ from 'jquery'

export default class extends Controller {
  static values = {
    delay: {type: Number, default: 5000},
    useDelay: {type: Boolean, default: true},
  }

  connect() {
    const init = () => {
      this.element.classList.remove('d-none')
      $(this.element).carousel()
    }

    if (this.useDelayValue)
      setTimeout(init, this.delayValue)
    else
      init()
  }
}
